import styled from 'styled-components';

export const CenteredPopoverContent = styled.div<{ $offset: number }>`
    transform: translateX(${(props) => props.$offset}px);
`;
